import { render, staticRenderFns } from "./IncomingCallNotices.vue?vue&type=template&id=6a33d370&scoped=true"
import script from "./IncomingCallNotices.vue?vue&type=script&lang=js"
export * from "./IncomingCallNotices.vue?vue&type=script&lang=js"
import style0 from "./IncomingCallNotices.vue?vue&type=style&index=0&id=6a33d370&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a33d370",
  null
  
)

export default component.exports